import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/livekit/button';
import { useAuth } from '@/hooks/useAuth';

export function LogoutButton() {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [isPending, setIsPending] = useState(false);

  const handleLogout = async () => {
    if (isPending) return;
    setIsPending(true);
    try {
      await logout();
    } finally {
      setIsPending(false);
    }
  };

  return (
    <Button variant="ghost" size="sm" onClick={handleLogout} disabled={isPending}>
      {isPending ? t('auth.loggingOut') : t('auth.logout')}
    </Button>
  );
}
